// extracted by mini-css-extract-plugin
export default {"tootlipContainer":"Tooltip2_tootlipContainer__B6dpO","icon":"Tooltip2_icon__fvpO9","tooltip":"Tooltip2_tooltip__5dWa8"};